import { toFixedNumber } from '../shared/helpers';
import { MONTHLY_1999_WITHOUT_TRIAL_PLAN, QUARTERLY_3999_WITHOUT_TRIAL_PLAN, WEEKLY_499_WITHOUT_TRIAL_PLAN } from '../shared/subscription-plans';

const subscriptionMapping = {
    [WEEKLY_499_WITHOUT_TRIAL_PLAN]: {
        name: '1-Week plan'
    },
    [MONTHLY_1999_WITHOUT_TRIAL_PLAN]: {
        name: '1-Month plan',
        isPopular: true
    },
    [QUARTERLY_3999_WITHOUT_TRIAL_PLAN]: {
        name: '3-Month plan',
    }
};

const DAYS_IN_MONTH = 30;
const QUARTERLY_MONTH = 3;
const DAYS_IN_WEEK = 7;

const getPricePerDay = ({plan, price}) => {
    if (plan === WEEKLY_499_WITHOUT_TRIAL_PLAN) {
        return Math.round(price / DAYS_IN_WEEK);
    }

    if (plan === QUARTERLY_3999_WITHOUT_TRIAL_PLAN) {
        return Math.round(price / (DAYS_IN_MONTH * QUARTERLY_MONTH));
    }

    return Math.round(price / DAYS_IN_MONTH);
};

const subscriptionPlanMapper = {
    toDomain(subscriptionData) {
        const data = subscriptionMapping[subscriptionData.plan];

        if (!data) {
            return null;
        }

        return {
            ...data,
            price: `$${toFixedNumber(subscriptionData.price / 100)}`,
            pricePerDay: getPricePerDay(subscriptionData),
            billingPeriod: subscriptionData.billingPeriod,
            plan: subscriptionData.plan,
            trial: subscriptionData.trial ? {...subscriptionData.trial, price: `$${toFixedNumber(subscriptionData.trial.price / 100)}`} : null
        }
    }
};

export {
    subscriptionPlanMapper
};
